export default __webpack_public_path__ + "static/media/Success.4eac56e4.mp3";